<div class=" card-wrapper">
  <form (ngSubmit)="onSubmit()" [formGroup]="applicationForm">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-9 col-lg-9 col-sm-12">
            <h3 class=" mb-0">Application Information</h3>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="p-2 mb-2">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Budget
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': applicationForm.get('budget')?.invalid
                               && applicationForm.get('budget')?.touched }"
                         class="form-control"
                         formControlName="budget"
                         type="number" step="1"
                         [min]="amountRange.min" [max]="amountRange.max">
                  <div *ngIf="applicationForm.get('budget')?.invalid && applicationForm.get('budget')?.touched" class="invalid-feedback">
                    <div *ngIf="applicationForm.get('budget')?.hasError('required')">Budget is required.</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('wholeNumber')">Please enter a whole number (no decimals).</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('min')">Budget cannot be negative.</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('max')">Budget cannot exceed {{ amountRange.max | number }}.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Currency
                </label>
                <div class="col-md-9">
                  <select [ngClass]="{ 'is-invalid': applicationForm.get('currencyId')?.invalid
                               && applicationForm.get('currencyId')?.touched }"
                          class="form-control"
                          formControlName="currencyId" id="currencyDdl">
                    <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                  </select>
                  <div class="invalid-feedback">
                    Currency is required.
                  </div>
                </div>
              </div>
            </div>

              <div *ngIf="graintApplicationStatus == 'Approved'" class="col-md-6 col-lg-6 col-sm-12">
                <div class="form-group row">
                  <label class="col-md-3 col-form-label form-control-label">
                    Granted Amount
                  </label>
                  <div class="col-md-9">
                    <input
                      class="form-control"
                      formControlName="grantedAmount"
                      type="number"
                      readonly
                    />
                  </div>
                </div>
              </div>



          </div>
          <div class="form-group">
            <label class="form-control-label">
              Application Title
            </label>
            <p class="text-muted small" style="display: block">
              Please write the title in English and use no more than {{ limits.applicationName }} characters (spaces included)
            </p>
            <input [ngClass]="{ 'is-invalid': applicationForm.get('applicationName')?.invalid
                               && applicationForm.get('applicationName')?.touched }" class="form-control"
                   formControlName="applicationName"
                   type="text"
                   [maxlength]="limits.applicationName">
            <app-char-counter [control]="applicationForm.get('applicationName')"
                              [max]="limits.applicationName"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('applicationName')?.hasError('required')
                          || applicationForm.get('applicationName')?.hasError('notBlank')">
                Application Title is required.
              </div>
              <div *ngIf="applicationForm.get('applicationName')?.hasError('maxlength')">
                Application Title cannot exceed {{ limits.applicationName }} characters.
              </div>
              <div *ngIf="applicationForm.get('applicationName')?.hasError('englishOnly')">
                Application Title must contain only English characters and basic special characters (no other languages allowed).
              </div>
            </div>
          </div>

          <div class="form-group">
            <label style="display: block" class="form-control-label">
              Purpose of Emergency support (Max {{ limits.fundingPupose }} characters)
            </label>
            <ul class="text-muted small" style="list-style-type: none; padding: 0;">
              <li>Please provide a short explanation of why you need emergency support,</li>
              <li>and in what way this support will help you to improve/solve the situation,</li>
              <li>or how the actions you will undertake with the emergency assistance will improve the situation</li>
            </ul>
            <textarea class="form-control"
                      [ngClass]="{ 'is-invalid': applicationForm.get('fundingPupose')?.invalid
                               && applicationForm.get('fundingPupose')?.touched }"
                      rows="7" formControlName="fundingPupose"></textarea>
            <app-char-counter [control]="applicationForm.get('fundingPupose')"
                              [max]="limits.fundingPupose"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('fundingPupose')?.hasError('required')
                          || applicationForm.get('fundingPupose')?.hasError('notBlank')">
                Purpose of Emergency support is required.
              </div>
              <div *ngIf="applicationForm.get('fundingPupose')?.hasError('maxlength')">
                Purpose of Emergency support cannot exceed {{ limits.fundingPupose }} characters (a line break counts as two).
              </div>
            </div>
          </div>

          <div class="form-group">
            <label style="display: block" class="form-control-label">
              Explanation of costs (Max {{ limits.costExplanation }} characters)
            </label>
            <ul class="text-muted small" style="list-style-type: none; padding: 0;">
              <li>Please explain how you will use the emergency funds.</li>
              <li>For amounts above 1000 EUR/USD, please attach a budget.</li>
            </ul>
            <textarea class="form-control"
                      [ngClass]="{ 'is-invalid': applicationForm.get('costExplanation')?.invalid
                               && applicationForm.get('costExplanation')?.touched }"
                      rows="7" formControlName="costExplanation"></textarea>
            <app-char-counter [control]="applicationForm.get('costExplanation')"
                              [max]="limits.costExplanation"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('costExplanation')?.hasError('required')
                          || applicationForm.get('costExplanation')?.hasError('notBlank')">
                Explanation of costs is required.
              </div>
              <div *ngIf="applicationForm.get('costExplanation')?.hasError('maxlength')">
                Explanation of costs cannot exceed {{ limits.costExplanation }} characters (a line break counts as two).
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-control-label">
            Emergency Funds Target
          </label>
          <select class="form-control"
                  [ngClass]="{ 'is-invalid': applicationForm.get('fundingTarget')?.invalid
                               && applicationForm.get('fundingTarget')?.touched }"
                  formControlName="fundingTarget">
            <option *ngFor="let value of fundTarget" [value]="value.id">{{ value.name }}</option>

          </select>
          <div class="invalid-feedback">
            Emergency Funds Target is required.
          </div>
        </div>
        <div >
          <button class="btn btn-primary" type="submit" [disabled]="graintApplicationStatus === 'Approved'  || this.isReadOnly">
            Submit
          </button>
        </div>

      </div>

    </div>

  </form>


</div>
